import {AdminMovebank, EsriProject, MovebankAccountCustomer, MovebankDeviceCustomer, MovebankManualDataUploadCustomer, MovebankServiceAction, MovebankUploadJobMonitoringRest} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public AdminMovebank: AdminMovebank,
    public EsriProject: EsriProject,
    public MovebankAccountCustomer: MovebankAccountCustomer,
    public MovebankDeviceCustomer: MovebankDeviceCustomer,
    public MovebankManualDataUploadCustomer: MovebankManualDataUploadCustomer,
    public MovebankServiceAction: MovebankServiceAction,
    public MovebankUploadJobMonitoringRest: MovebankUploadJobMonitoringRest,
  ) {}
}